import { OnInit, Component } from "@angular/core";
import { Globals } from "../globals";
import { Router } from "@angular/router";
import { MasterDataService } from "../masterdata/masterdata.service";
import { ErrorHandler } from "../utils/error-handler";
import { MessagesService } from "../messages/messages.service";
import { LabEmitterService } from "../common-services/lab-emitter.service"
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode'
import { SelectableLab } from "../masterdata/models/lab";

// Lab component to handle lab on inital page load
// @author Naveen
@Component({
  selector: 'app-lab',
  templateUrl: './lab.component.html',
  styleUrls: ['./lab.component.css']
})
export class LabComponent implements OnInit {

  selectedLab: SelectableLab;
  errorHandler: ErrorHandler = new ErrorHandler;
  labs: SelectableLab[];
  isLabSelected: boolean = false;
  loggedUserName:string;
  constructor(private _globals: Globals, private router: Router, private _masterDataService: MasterDataService,
    private _messageService: MessagesService, private _labEmitterService: LabEmitterService) {

  }

  //loads the all lab
  ngOnInit() {
    let selectedLab = JSON.parse(localStorage.getItem('lab'))
    if (selectedLab) {
      this.isLabSelected = true;
    }
    setTimeout(() => {
			this.getLabs()
		}, 2000);
  }

  getLabs(){
    this._masterDataService.getLabsWithOptionalHistory(true, false).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("labs:", results.data);
        this.labs = [];
        results.data.forEach(lab => {
          this.labs.push({ label: lab.name, lab: lab })
        });

      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }
  
  checkAndAssignDateFormat(){
    if(this.selectedLab.lab.dateFormat == undefined ||this.selectedLab.lab.dateFormat == null){
      this.selectedLab.lab.dateFormat = 'dd.MM.yyyy'
    }
    if(this.selectedLab.lab.dateTimeFormat == undefined ||this.selectedLab.lab.dateTimeFormat == null){
      this.selectedLab.lab.dateTimeFormat = 'dd.MM.yyyy HH:mm:ss'
    }
    if(this.selectedLab.lab.workfileNameFormat == undefined ||this.selectedLab.lab.workfileNameFormat == null){
      this.selectedLab.lab.workfileNameFormat = 'yyyyMMdd_HHmmss'
    }
  }

  // Assigns selected lab and loads application
  assignLabAndLoad(event) {
    this.checkAndAssignDateFormat()
    console.log("Lab selected: " + this.selectedLab.label)
    localStorage.setItem('lab', JSON.stringify(this.selectedLab));
    this._globals.selectedLab = this.selectedLab;
    this._labEmitterService.emitLab(this.selectedLab)
    this.router.navigate(['/']);
  }
  azureLogOut() {
    const util = new AuthUtil()
    util.logout()
  }
  get azureLoginStatus() {
    let authUtil = new AuthUtil()
    let accessToken = authUtil.getAccessToken()
    if(accessToken)
    {
    let access_token = jwt_decode(accessToken);
    this.loggedUserName= access_token.name;
    }
    return accessToken ? true: false
}

}


